/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api/cat_7070
 */

import { message } from 'ant-design-vue'
import {
  recall_cart2_config_query_get,
  recall_cart2_config_update_post,
  recall_cart2_email_list_post,
  recall_cart2_email_resend_id_post,
  recall_cart2_manual_get
} from 'server/modules/7070'

// 弃单召回邮件配置查询
export const recall_cart2_config_query_get_ = async function(params, state) {
  const { success, data, retInfo } = await recall_cart2_config_query_get(params)
  if (success) {
    const { recallTime, intervalTime, active, checkSubscribe } = data
    state.timeParams = {
      ...state.timeParams,
      recallTime,
      intervalTime,
      active,
      checkSubscribe
    }
  } else {
    message.error(retInfo)
  }
}

// 修改弃单召回邮件配置
export const recall_cart2_config_update_post_ = async function(params) {
  const { success, retInfo } = await recall_cart2_config_update_post(params)
  if (success) {
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 邮件发送列表查询
export const recall_cart2_email_list_post_ = async function(params, state) {
  const { success, data, retInfo } = await recall_cart2_email_list_post(params)
  if (success) {
    const { total, list, pageNum } = data
    state.pagination = { ...state.pagination, total, pageNum }
    state.dataSource = list
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 邮件重新发送
export const recall_cart2_email_resend_id_post_ = async function(
  params,
  state
) {
  const { success, data, retInfo } = await recall_cart2_email_resend_id_post(
    params
  )
  if (success) {
    if (data) {
      state.initList()
      message.success(retInfo)
    } else {
      message.error('发送失败！')
    }
  } else {
    message.error(retInfo)
  }
}

// 手动调用（测试用）
export const recall_cart2_manual_get_ = async function(params) {
  const { success, data, retInfo } = await recall_cart2_manual_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
